import React from "react";
import "react-table/react-table.css";
import enhance from "./enhance";
import TableData from "./TableData";

export const WorkstationTableData = (props) => {
  const { getHistoryData, isHistoryDataClicked } = props;
  /* istanbul ignore next */
  return (
    <div>
      <TableData
        data={props.data}
        getHistoryData={getHistoryData}
        isHistoryDataClicked={isHistoryDataClicked}
        category="device Workstation"
      />
    </div>
  );
};
export default enhance(WorkstationTableData);
